import store from "@/store";

import Index from "@/pages/roma/Index";
import Home from "@/pages/roma/Home";
import Introduction from "@/pages/roma/Introduction";
import Origin from "@/pages/roma/Origin";
import Past from "@/pages/roma/Past";
import Progress from "@/pages/roma/Progress";
import Future from "@/pages/roma/Future";

export default {
  path: "/roma",
  component: Index,
  beforeEnter(to, from, next) {
    store.dispatch("loadPage", "explore-roma-street").then(next);
  },
  meta: {
    label: "Roma Street",
    group: "Stations"
  },
  children: [
    {
      path: "",
      name: "Roma Street Home",
      component: Home,
      meta: {
        label: "Home",
        hide: true
      }
    },
    {
      path: "intro",
      name: "Roma Street Introduction",
      component: Introduction,
      meta: {
        label: "Introduction",
        showSidebar: true
      }
    },
    {
      path: "origin",
      name: "Roma Street Origin",
      component: Origin,
      meta: {
        child: true,
        label: "Origin"
      }
    },
    {
      path: "past",
      name: "Roma Street Past",
      component: Past,
      meta: {
        child: true,
        label: "Past"
      }
    },
    {
      path: "progress",
      name: "Roma Street Progress",
      component: Progress,
      meta: {
        child: true,
        label: "Progress"
      }
    },
    {
      path: "future",
      name: "Roma Street Future",
      component: Future,
      meta: {
        child: true,
        label: "Future"
      }
    }
  ]
};
